import CalendarApp from './js/administration/app';

window.CalendarApp = CalendarApp;